import { render } from "./Products.vue?vue&type=template&id=269fdf85&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=269fdf85&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269fdf85"],['__file',"src/views/Products/Products.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "269fdf85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('269fdf85', __exports__)) {
    api.reload('269fdf85', __exports__)
  }
  
  module.hot.accept("./Products.vue?vue&type=template&id=269fdf85&scoped=true", () => {
    api.rerender('269fdf85', render)
  })

}


export default __exports__